import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import TokenCallback from "./components/TokenCallback";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import CRTOverlay from "./components/CRTOverlay";
import Home from "./pages/Home";
import Checkpoints from "./pages/Checkpoints";
import CheckpointDetail from "./pages/CheckpointDetail";
import Upload from "./pages/Upload";
import UserProfile from "./pages/UserProfile";
import About from "./pages/About";
import Paper from "./pages/Paper";
import NotFound from "./pages/NotFound";
import Admin from "./pages/Admin";
import LinkApp from './pages/LinkApp';
import Train from './pages/Train';
import Run from './pages/Run';
import Credits from './pages/Credits';
import Workspace from './pages/Workspace';
import Data from './pages/Data';
import Remote from './pages/Remote';
import Info from "./pages/Info";
import Blog from "./pages/Blog";
import Downloads from "./pages/Downloads";
import Chat from "./pages/Chat";
import RuntimeSpec from "./pages/RuntimeSpec";
import Developments from "./pages/Developments";
import Development from "./pages/Development";

function AppRouter() {
  const location = useLocation();
  
  // Handle token callback (returning from Google OAuth via backend)
  if (location.hash?.includes('token=')) {
    return <TokenCallback />;
  }

  return (
    <>
      <Navigation />
      <main role="main" id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checkpoints" element={<Checkpoints />} />
          <Route path="/checkpoints/:checkpointId" element={<CheckpointDetail />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/u/:username" element={<UserProfile />} />
          <Route path="/creators" element={<Navigate to="/checkpoints?tab=creators" replace />} />
          <Route path="/feed/following" element={<Navigate to="/?tab=following" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/info" element={<Info />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/paper" element={<Paper />} />
          <Route path="/specs" element={<Navigate to="/runtimes/current" replace />} />
          <Route path="/specs/v14" element={<Navigate to="/runtimes/v14" replace />} />
          <Route path="/runtimes" element={<Navigate to="/downloads" replace />} />
          <Route path="/runtimes/:runtimeId" element={<RuntimeSpec />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/developments" element={<Developments />} />
          <Route path="/developments/:slug" element={<Development />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/link" element={<LinkApp />} />
          <Route path="/train" element={<Train />} />
          <Route path="/runs/:runId" element={<Run />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/data" element={<Data />} />
          <Route path="/remote/:tokenId" element={<Remote />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-black flex flex-col" style={{
      paddingLeft: 'env(safe-area-inset-left)', paddingRight: 'env(safe-area-inset-right)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <CRTOverlay />
    </div>
  );
}

export default App;
